var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('p',{staticClass:"loading__text"},[_vm._v("loading...")])])
}]

export { render, staticRenderFns }